module.exports = __webpack_public_path__ + "static/media/main_bg_samsung.42f7746e.png";